import React from "react"
import { Typography } from '@mui/material'
import ModifyRanking from './components/ModifyRanking'

export default function ManageRanking() {
    return (
        <section>
            <Typography variant="h2">Change datasets ranking</Typography>
            <ModifyRanking/>
        </section>
    )
} 